/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Minifier_Deep_P1Inputs */

const en_minifier_deep_p1 = /** @type {(inputs: Minifier_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Raw minification numbers look impressive and are usually quoted on their own, which is misleading for anything served over HTTP. Almost every server and CDN already applies gzip or brotli, and compressors are extremely good at repeated whitespace. Indentation is the most repetitive content in a pretty printed document, so it is precisely what gzip eliminates for free.`)
};

const ko_minifier_deep_p1 = /** @type {(inputs: Minifier_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`압축률 수치는 단독으로 인용될 때 인상적으로 보이지만, HTTP로 전송되는 것에 대해서는 오해를 부릅니다. 거의 모든 서버와 CDN이 이미 gzip이나 brotli를 적용하고, 압축기는 반복되는 공백을 아주 잘 처리합니다. 들여쓰기는 정렬된 문서에서 가장 반복적인 내용이고, 따라서 gzip이 공짜로 제거해주는 바로 그 대상입니다.`)
};

const ja_minifier_deep_p1 = /** @type {(inputs: Minifier_Deep_P1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`圧縮率の数字は単独で引用されると印象的ですが、HTTP で転送されるものについては誤解を招きます。ほぼすべてのサーバと CDN がすでに gzip か brotli を適用しており、圧縮器は繰り返しの空白をきわめてうまく扱います。インデントは整形済み文書の中で最も反復的な内容で、つまり gzip が無料で消してくれるまさにその対象です。`)
};

/**
* | output |
* | --- |
* | "Raw minification numbers look impressive and are usually quoted on their own, which is misleading for anything served over HTTP. Almost every server and CDN ..." |
*
* @param {Minifier_Deep_P1Inputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const minifier_deep_p1 = /** @type {((inputs?: Minifier_Deep_P1Inputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Minifier_Deep_P1Inputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_minifier_deep_p1(inputs)
	if (locale === "ko") return ko_minifier_deep_p1(inputs)
	return ja_minifier_deep_p1(inputs)
});